import { render, staticRenderFns } from "./foodcategorydetails.vue?vue&type=template&id=a9631abe&scoped=true&"
import script from "./foodcategorydetails.vue?vue&type=script&lang=js&"
export * from "./foodcategorydetails.vue?vue&type=script&lang=js&"
import style0 from "./foodcategorydetails.vue?vue&type=style&index=0&id=a9631abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9631abe",
  null
  
)

export default component.exports